<nav *ngIf="!(showMenu$ | async)" (click)="openNav($event)" id="navbarSupportedContent">
  <div class="icons">
    <es-icon name="person"></es-icon>
    <es-icon name="arrow-dropdown"></es-icon>
  </div>
</nav>

<nav *ngIf="showMenu$ | async" (click)="closeNav($event)" id="navbarSupportedContent">
  <div class="icons">
    <es-icon name="person"></es-icon>
    <es-icon name="arrow-dropup"></es-icon>
  </div>
  <ul [class.hide]="!(showMenu$ | async)">
    <li *ngIf="fullName">
      <span>{{fullName}}</span>
    </li>
    <li>
      <a target="_blank" href="https://examsoft.force.com/emcommunity/s/" translate>Help Center</a>
    </li>
    <li>
      <a href="/" translate>home</a>
    </li>
    <li *ngIf="isAdmin">
      <a (click)="showTimer()" translate>Timer</a>
    </li>
    <li>
      <a class="btn btn-primary nav-link" (click)="signOut()">
        <span translate>Sign Out</span>
        <i class="ion-log-in" data-pack="default" data-tags="sign in"></i>
      </a>
    </li>
  </ul>
</nav>
